import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import React from 'react';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const SimilarQualitiesExplanation = ({
  controlVariableDisplayNames,
}: {
  controlVariableDisplayNames: string[];
}) => {
  const firstControlVariableNames = controlVariableDisplayNames.slice(
    0,
    controlVariableDisplayNames.length === 10 ? 10 : 9,
  );

  const language = useLanguage();

  return (
    <Spacing direction={'vertical'} size={'none'}>
      <S2Typography
        variant={'small-label-alt'}
        textColorVariant={'gray-900'}
        translatedContent={language.similarFactors()}
      />
      <ul
        className={
          'list-inside list-disc font-sans text-xxs leading-normal text-gray-900'
        }
      >
        <>
          {firstControlVariableNames.map(
            (controlVariableDisplayName, index) => (
              <li key={index}>
                <S2Typography
                  as={'span'}
                  variant={'small-label'}
                  textColorVariant={'gray-900'}
                  translatedContent={language.controlVariableName({
                    name: controlVariableDisplayName,
                  })}
                />
              </li>
            ),
          )}
          {controlVariableDisplayNames.length > 10 && (
            <li>
              <S2Typography
                as={'span'}
                variant={'small-label'}
                textColorVariant={'gray-900'}
                translatedContent={language.plusSomeMore({
                  count: controlVariableDisplayNames.length - 9,
                })}
              />
            </li>
          )}
        </>
      </ul>
    </Spacing>
  );
};
